import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogActions } from '@angular/material/dialog';


@Component({
  selector: 'app-quote-referred-declined',
  standalone: true,
  imports: [MatDialogActions],
  templateUrl: './quote-referred-declined.component.html',
  styleUrl: './quote-referred-declined.component.scss'
})
export class QuoteReferredDeclinedComponent {
  constructor(private dialogRef: MatDialogRef<QuoteReferredDeclinedComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { message: string }
  ) {}

  onSuccessResponse() {
    this.dialogRef.close(true);     
  }

  onNegativeResponse() {
    this.dialogRef.close();
  }
}
